import type { ThemeColors } from '../../../../tokens/colors/types';
import { border } from './border';
import { divider } from './divider';
import edColors from './ED';
import { blue, green, neutral, orange, pale, purple, red } from './palette';
import { deals, retail } from './product';
import { critical, info, positive, shout, warning } from './semantic';
import { typography } from './typography';

const primary = {
  '10': '#FFF7F3',
  '20': '#FFF0E6',
  '30': '#FF944D',
  '50': '#FF6600',
  '70': '#C24E00',
  '80': '#262626',
  '90': '#262626',
};

// TODO: This colors should be defined. For backward-compatibility they are the same as eDreams but it's wrong.
const secondary = edColors.secondary;

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  pale,
  info,
  warning,
  critical,
  positive,
  deals,
  retail,
  shout,
  border,
  divider,
  typography,
};

export default baseColors;
